export default __webpack_public_path__ + "static/media/double-tick.496a84ab.svg";